import styled from 'styled-components';

export const InfoBarOuterContainer = styled.div`
  display: flex;
  width: 100%;
  position: relative;

  > * {
    width: 100%;
  }
  > .hidden {
    visibility: hidden;
  }
`;

export const InfoBarLoaderContainer = styled.div`
  display: flex;
  align-items: center;
  margin-right: var(--sizing-xs);
  position: absolute;
  width: 100%;
  height: 100%;

  & > * {
    width: 100%;
    height: 100%;
  }
`;

export const SpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  margin: 0px var(--sizing-md) 0px var(--sizing-sm);

  p {
    color: var(--text-gray);
  }
`;

export const SpinnerText = styled.p`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;

  color: var(--text-gray);
`;
